import { ICellRendererParams } from 'ag-grid-community';
import { Link } from '@mui/material';
import { TableV3ColDefs } from 'common/table';
import { SourcingInternalSelectedCandidateProfileTableData } from 'modules/sourcing-internal/tables/types/SourcingInternalSelectedCandidateProfileTableData';
import { ActionPopover } from 'components/ActionPopover';
import { SelectedCandidateProfileNameCell } from '../components/SelectedCandidateProfileNameCell';

type GetSourcingInternalSelectedCandidateProfileColumnsProps = {
  handleRemove: (
    row: SourcingInternalSelectedCandidateProfileTableData
  ) => void;
};

export const getSourcingInternalSelectedCandidateProfileColumns = ({
  handleRemove
}: GetSourcingInternalSelectedCandidateProfileColumnsProps): TableV3ColDefs<
  SourcingInternalSelectedCandidateProfileTableData,
  never
> => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    cellRenderer: (
      params: ICellRendererParams<SourcingInternalSelectedCandidateProfileTableData>
    ) => {
      if (!params.data) {
        return null;
      }

      return (
        <SelectedCandidateProfileNameCell
          name={params.data.name}
          inviteStatus={params.data.inviteStatus}
        />
      );
    }
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 1
  },
  {
    field: 'currentRole',
    headerName: 'Current Role',
    flex: 1
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
    cellRenderer: (
      params: ICellRendererParams<SourcingInternalSelectedCandidateProfileTableData>
    ) => {
      if (!params.data || !params.data.email) {
        return '-';
      }
      return (
        <Link href={`mailto:${params.data.email}`}>{params.data.email}</Link>
      );
    }
  },
  {
    field: 'phone',
    headerName: 'Phone',
    flex: 1,
    cellRenderer: (
      params: ICellRendererParams<SourcingInternalSelectedCandidateProfileTableData>
    ) => {
      if (!params.data || !params.data.phone) {
        return '-';
      }
      return <Link href={`tel:${params.data.phone}`}>{params.data.phone}</Link>;
    }
  },
  {
    field: 'id',
    headerName: '',
    width: 45,
    cellStyle: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-start'
    },
    cellRenderer: (
      params: ICellRendererParams<SourcingInternalSelectedCandidateProfileTableData>
    ) => {
      const data = params.data;
      if (!data) {
        return null;
      }

      return (
        <ActionPopover
          id={data.id}
          options={[
            {
              label: 'Remove',
              onClick: () => handleRemove(data),
              itemColor: 'error.main'
            }
          ]}
        />
      );
    }
  }
];
